import React, { useEffect, useState } from 'react'
import { Dialog, DialogActions, DialogContent, DialogTitle, IconButton, LinearProgress, Tooltip } from "@mui/material";

import { Add, Edit } from '@mui/icons-material';
import essWorkReportServices from '../essWorkReportServices';
import { useAlert } from '../../../../context/AlertContext';


function EssWorkReportForm({data,callBack }) {

    const [report,setReport] = useState ("");
    const {AppAlert} = useAlert()
    const [dialogStatus,setDialogStatus] = useState(false);
    const [saving, setSavingStatus] = useState(false);
    
    

    const onSubmit = ( onSubmitProps) => {
        let payload ={
            report:report,
        }
        if(data){
            payload.id=data.id
        }
        essWorkReportServices.save(payload).then(res=>{
            AppAlert(res.msg);
            setDialogStatus(false);
            callBack();
        }).catch(error=>{
            AppAlert(error.msg,"error");
        }).finally(()=>{
            setSavingStatus(false);
        })
    }

    const addNew =() =>{
        setReport("");
        setDialogStatus(true);
    }

    const updateData = () =>{
        setReport(data.report);
        setDialogStatus(true);
    }

    return (
        <>
            {!data &&
                <Tooltip title="Add New">
                    <button type="button" className="btn btn-primary" onClick={addNew} >Add Work Report</button>
                </Tooltip>
            }
            {data &&
                <Tooltip title="Update">
                    <IconButton onClick={updateData} style={{padding:"0px"}}>
                        <Edit/>
                    </IconButton>
                </Tooltip>
            }
            <Dialog
                open={dialogStatus}
                keepMounted
                onClose={()=>setDialogStatus(false)}
                fullWidth={true}
                maxWidth="md"
            >
                <DialogContent>
                    <div className='mb-3'>
                        <label className='fw-bold'>Report</label>
                        <textarea className='form-control mt-3' rows={5} value={report} onChange={(e)=>setReport(e.target.value)} />
                    </div>
                </DialogContent>
                <DialogActions>
                    <button className='btn btn-outline-primary' onClick={()=>setDialogStatus(false)}>Cancel</button>
                    <button className='btn btn-primary' onClick={onSubmit} type='button'>Save</button>
                    
                </DialogActions>
            </Dialog>

        </>
    )
}

export default EssWorkReportForm